module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"optimizerDataError":"Error loading optimizer data","missingPeriods":"No optimizer options for this point of sale"},"es":{"missingPeriods":"No hay opciones de optimización para este periodo","optimizerDataError":"Error cargando datos del optimizador"}}')
  delete Component.options._Ctor
}
